export const leaderboardKeys = {
    leaderboard: (subdomain, sprintId) => sprintId ? ['leaderboard', subdomain, sprintId] : ['leaderboard', subdomain],
    stats: (subdomain, sprintId) => sprintId ? ['leaderboard', 'stats', subdomain, sprintId] : ['leaderboard', 'stats', subdomain],
    sprints: (subdomain, sprintId) => sprintId ? ['sprints', subdomain, sprintId] : ['sprints', subdomain],
    rank: (subdomain, userId, sprintId) => sprintId ? ['rank', subdomain, userId, sprintId] : ['rank', subdomain, userId],
    upcomingAndRecentSprints: () => ['upcomingAndRecentSprints'],
    sprintClaimsReviewed: (subdomain, sprintId) => [
        'sprint',
        'claims-reviewed',
        subdomain,
        sprintId,
    ],
};
